/* BEK Le Feu Familien-Banner (Claude 2026-08) */
(function () {
  if (window.__bekEyeInit) return;
  window.__bekEyeInit = true;

  var suppress = false;
  var LEAVE_MS = 840; /* etwas laenger als die CSS-Transition (.8s) */

  /* Alle Slides liegen uebereinander, die inaktiven sind visibility:hidden.
     Chrome laedt loading="lazy"-Bilder in unsichtbaren Elementen nicht, dadurch waere
     der Bildbereich nach einem Slide-Wechsel kurz leer. Deshalb wird das Zielbild und
     jeweils der linke und rechte Nachbar vorab auf eager gestellt.
     setAttribute loest nur eine attributes-Mutation aus, der MutationObserver unten
     lauscht ausschliesslich auf childList - keine Endlosschleife. */
  function eagerLoad(slide) {
    if (!slide) return;
    var im = slide.querySelector('img');
    if (im && im.getAttribute('loading') !== 'eager') im.setAttribute('loading', 'eager');
  }

  function slideByIndex(root, n, total) {
    n = ((n - 1) % total + total) % total + 1;
    return root.querySelector('[data-bek-eye-slide="' + n + '"]');
  }

  function preloadNearbySlides(root, idx, total, force) {
    function warm(current) {
      eagerLoad(slideByIndex(root, current, total));
      eagerLoad(slideByIndex(root, current + 1, total));
      eagerLoad(slideByIndex(root, current - 1, total));
    }
    var rect = root.getBoundingClientRect();
    if (force || !('IntersectionObserver' in window) ||
        (rect.top <= window.innerHeight + 800 && rect.bottom >= -800)) {
      if (root.__bekPreloadObserver) {
        root.__bekPreloadObserver.disconnect();
        root.__bekPreloadObserver = null;
      }
      warm(idx);
      return;
    }
    if (root.__bekPreloadObserver) return;
    root.__bekPreloadObserver = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) continue;
        warm(parseInt(root.getAttribute('data-bek-eye-index') || '1', 10));
        root.__bekPreloadObserver.disconnect();
        root.__bekPreloadObserver = null;
        break;
      }
    }, { rootMargin: '800px' });
    root.__bekPreloadObserver.observe(root);
  }

  /* Animation neu starten: Klasse entfernen, Reflow erzwingen, Klasse setzen. */
  function replay(el, cls) {
    if (!el) return;
    el.classList.remove(cls);
    void el.offsetWidth;
    el.classList.add(cls);
  }

  /* Kuerzester Weg im Ring, damit der Sprung vom letzten auf den ersten Slide
     nicht rueckwaerts durchlaeuft. */
  function shortestDir(from, to, n) {
    if (!from || from === to) return 0;
    var d = to - from;
    if (d > n / 2) d -= n;
    if (d < -n / 2) d += n;
    return d > 0 ? 1 : -1;
  }

  /* Bei schnellem Weiterklicken laeuft der vorige Abgang noch. Wird er nicht beendet,
     bleibt ein halbtransparentes Geisterbild stehen, bis sein Timeout faellt. */
  function clearLeaving(root) {
    if (root.__bekLeaveT) { clearTimeout(root.__bekLeaveT); root.__bekLeaveT = null; }
    var old = root.querySelectorAll('[data-bek-eye-slide].is-leaving');
    for (var i = 0; i < old.length; i++) old[i].classList.remove('is-leaving');
  }

  /* Richtung umstellen, ohne dass die wartenden Slides von der alten auf die neue
     Warteposition hinueberanimieren. Ohne das Abschalten der Transitions startet der
     eingehende Slide von der falschen Seite: er stuende noch rechts, waehrend er nach
     einem Rueckwaertsklick von links hereinkommen soll. */
  function setDir(root, dir) {
    if (!dir || root.getAttribute('data-dir') === String(dir)) return;
    var ready = root.classList.contains('is-ready');
    if (ready) root.classList.remove('is-ready');
    root.setAttribute('data-dir', String(dir));
    void root.offsetWidth;
    if (ready) {
      root.classList.add('is-ready');
      void root.offsetWidth;
    }
  }

  function setSlide(root, idx, animate) {
    var slides = root.querySelectorAll('[data-bek-eye-slide]');
    var n = slides.length;
    if (!n) return;
    idx = ((idx - 1) % n + n) % n + 1;
    var prevIdx = parseInt(root.getAttribute('data-bek-eye-index') || '0', 10);
    if (animate && prevIdx === idx) return;
    suppress = true;

    var leaving = null;
    if (animate) {
      clearLeaving(root);
      setDir(root, shortestDir(prevIdx, idx, n));
      leaving = root.querySelector('[data-bek-eye-slide].is-active');
      /* Der eingehende Slide muss seinen Startversatz haben, bevor is-active gesetzt wird,
         sonst fasst der Browser Start- und Endzustand zusammen und es gibt keine Bewegung. */
      void root.offsetWidth;
      if (leaving) {
        leaving.classList.add('is-leaving');
        root.__bekLeaveT = setTimeout(function () {
          leaving.classList.remove('is-leaving');
          root.__bekLeaveT = null;
        }, LEAVE_MS);
      }
    }

    var active = null;
    for (var i = 0; i < n; i++) {
      var on = slides[i].getAttribute('data-bek-eye-slide') === String(idx);
      slides[i].classList.toggle('is-active', on);
      slides[i].setAttribute('tabindex', on ? '0' : '-1');
      slides[i].setAttribute('aria-hidden', on ? 'false' : 'true');
      if (on) active = slides[i];
      if (on && slides[i] === leaving) slides[i].classList.remove('is-leaving');
    }
    preloadNearbySlides(root, idx, n, animate);
    var dots = root.querySelectorAll('[data-bek-eye-dot]');
    for (var j = 0; j < dots.length; j++) {
      var dotOn = dots[j].getAttribute('data-bek-eye-dot') === String(idx);
      dots[j].classList.toggle('is-active', dotOn);
      if (dots[j].tagName === 'BUTTON') dots[j].setAttribute('aria-pressed', dotOn ? 'true' : 'false');
    }
    /* Zweidimensionale Banner: die Buttons beider Achsen richten sich nach den
       Achswerten des aktiven Slides, nicht nach dem Slide-Index. */
    if (active) {
      var axisBtns = root.querySelectorAll('[data-bek-eye-axis]');
      for (var a = 0; a < axisBtns.length; a++) {
        var ax = axisBtns[a].getAttribute('data-bek-eye-axis');
        var primary = active.getAttribute('data-axis-' + ax);
        var alternate = active.getAttribute('data-axis-' + ax + '-alt');
        var chosen = root.getAttribute('data-selected-' + ax);
        var want = chosen && (chosen === primary || chosen === alternate) ? chosen : primary;
        if (want !== null) root.setAttribute('data-selected-' + ax, want);
        var axisOn = axisBtns[a].getAttribute('data-axis-value') === want;
        axisBtns[a].classList.toggle('is-active', axisOn);
        if (axisBtns[a].tagName === 'BUTTON') axisBtns[a].setAttribute('aria-pressed', axisOn ? 'true' : 'false');
      }
      var mobileSelects = root.querySelectorAll('[data-bek-eye-mobile-select]');
      for (var ms = 0; ms < mobileSelects.length; ms++) {
        var selectAxis = mobileSelects[ms].getAttribute('data-bek-eye-mobile-select');
        var selectValue = root.getAttribute('data-selected-' + selectAxis) || active.getAttribute('data-axis-' + selectAxis);
        if (selectValue !== null && mobileSelects[ms].value !== selectValue) {
          mobileSelects[ms].value = selectValue;
        }
      }
    }
    if (root.getAttribute('data-bek-eye-index') !== String(idx)) {
      root.setAttribute('data-bek-eye-index', String(idx));
    }
    if (active) {
      /* Alle CTA-Ziele mitziehen: Hauptbutton auf die Produktseite, ein optionaler
         Wunschfarben-Link auf dieselbe Seite mit vorgewaehlter Aufpreis-Variante. */
      var ctas = root.querySelectorAll('[data-bek-eye-cta]');
      var url = active.getAttribute('data-url');
      var selectedL2 = root.getAttribute('data-selected-l2');
      var selectedL3 = root.getAttribute('data-selected-l3');
      if (selectedL2 && selectedL2 === active.getAttribute('data-axis-l2-alt')) {
        url = active.getAttribute('data-url-alt') || url;
      }
      if (selectedL3 && selectedL3 === active.getAttribute('data-axis-l3-alt')) {
        url = active.getAttribute('data-url-alt') || url;
      }
      for (var c = 0; c < ctas.length; c++) {
        if (url && ctas[c].getAttribute('href') !== url) ctas[c].setAttribute('href', url);
      }
      var mainLinks = root.querySelectorAll('[data-bek-eye-main-link]');
      for (var ml = 0; ml < mainLinks.length; ml++) {
        if (url && mainLinks[ml].getAttribute('href') !== url) mainLinks[ml].setAttribute('href', url);
      }
      if (url) root.setAttribute('data-bek-eye-current-url', url);
      var rals = root.querySelectorAll('[data-bek-eye-ral]');
      var ralUrl = active.getAttribute('data-ral-url');
      for (var r = 0; r < rals.length; r++) {
        if (ralUrl && rals[r].getAttribute('href') !== ralUrl) rals[r].setAttribute('href', ralUrl);
      }
      var lab = root.querySelector('[data-bek-eye-label]');
      var txt = active.getAttribute('data-label');
      if (lab && lab.textContent !== txt) {
        lab.textContent = txt;
        if (animate) replay(lab.parentNode, 'is-swap');
      }
      var l2lab = root.querySelector('[data-bek-eye-l2label]');
      var l2v = root.getAttribute('data-selected-l2') || active.getAttribute('data-axis-l2');
      if (l2lab && l2v && l2lab.textContent !== l2v) {
        l2lab.textContent = l2v;
        if (animate) replay(l2lab.parentNode, 'is-swap');
      }
      var l3lab = root.querySelector('[data-bek-eye-l3label]');
      var l3v = root.getAttribute('data-selected-l3') || active.getAttribute('data-axis-l3');
      if (l3lab && l3v && l3lab.textContent !== l3v) {
        l3lab.textContent = l3v;
        if (animate) replay(l3lab.parentNode, 'is-swap');
      }
      var pri = root.querySelector('[data-bek-eye-price]');
      var pv = active.getAttribute('data-price');
      if (pri && pv && pri.textContent !== pv) {
        pri.textContent = pv;
        if (animate) replay(pri.parentNode, 'is-swap');
      }
    }
    setTimeout(function () { suppress = false; }, 0);
  }

  /* Achswerte eines Banners in Erstauftritts-Reihenfolge einsammeln. */
  function axisValues(root, axis) {
    var all = root.querySelectorAll('[data-bek-eye-slide]');
    var out = [];
    for (var i = 0; i < all.length; i++) {
      var v = all[i].getAttribute('data-axis-' + axis);
      if (v === null) continue;
      if (out.indexOf(v) < 0) out.push(v);
    }
    return out;
  }

  function findSlide(root, color, l2) {
    var all = root.querySelectorAll('[data-bek-eye-slide]');
    for (var i = 0; i < all.length; i++) {
      if (all[i].getAttribute('data-axis-color') === color && all[i].getAttribute('data-axis-l2') === l2) return all[i];
    }
    return null;
  }

  /* Beim ersten Bedienen des Sliders alle restlichen Bilder nachladen, damit weiteres
     Blaettern ohne Verzoegerung laeuft. */
  function eagerAll(root) {
    var slides = root.querySelectorAll('[data-bek-eye-slide]');
    for (var i = 0; i < slides.length; i++) eagerLoad(slides[i]);
  }

  /* a11y (Claude, 2026-09-28): Video-Modal als Dialog mit Fokusfuehrung und Fokus-Rueckgabe.
     Fokusfalle ueber inert auf den uebrigen body-Kindern statt Keydown-Abfangen: so bleiben
     die nativen Videosteuerelemente per Tab erreichbar, und aus dem YouTube-iframe kann der
     Fokus nicht auf die verdeckte Seite entweichen. */
  var modalReturnFocus = null;
  var modalInerted = [];

  function setPageInert(m) {
    var kids = document.body ? document.body.children : [];
    for (var i = 0; i < kids.length; i++) {
      var k = kids[i];
      if (k === m || k.hasAttribute('inert')) continue;
      k.setAttribute('inert', '');
      modalInerted.push(k);
    }
  }

  function clearPageInert() {
    for (var i = 0; i < modalInerted.length; i++) modalInerted[i].removeAttribute('inert');
    modalInerted = [];
  }

  function closeModal() {
    var m = document.getElementById('bekEyeModal');
    var hadModal = !!m;
    if (m) {
      var v = m.querySelector('video');
      if (v) { try { v.pause(); v.removeAttribute('src'); v.load(); } catch (e) {} }
      if (m.parentNode) m.parentNode.removeChild(m);
    }
    clearPageInert();
    document.documentElement.style.overflow = '';
    if (hadModal && modalReturnFocus && document.contains(modalReturnFocus)) {
      try { modalReturnFocus.focus({ preventScroll: true }); } catch (e) {}
    }
    if (hadModal) modalReturnFocus = null;
  }

  /* Rueckfall fuer Browser ohne inert: Fokus ausserhalb des offenen Modals zurueckholen. */
  document.addEventListener('focusin', function (e) {
    var m = document.getElementById('bekEyeModal');
    if (!m || m.contains(e.target)) return;
    var closeBtn = m.querySelector('.bek-eye-modal__close');
    if (closeBtn) { try { closeBtn.focus({ preventScroll: true }); } catch (err) {} }
  });

  function buildModal(innerHtml, label) {
    var opener = document.activeElement;
    closeModal();
    modalReturnFocus = (opener && opener !== document.body) ? opener : null;
    var m = document.createElement('div');
    m.className = 'bek-eye-modal';
    m.id = 'bekEyeModal';
    m.setAttribute('role', 'dialog');
    m.setAttribute('aria-modal', 'true');
    m.setAttribute('aria-label', label || 'Produktvideo');
    m.innerHTML = '<div class="bek-eye-modal__box"><button type="button" class="bek-eye-modal__close" data-bek-eye-modal-close aria-label="Schließen">&times;</button>' + innerHtml + '</div>';
    m.addEventListener('click', function (ev) { if (ev.target === m) closeModal(); });
    document.body.appendChild(m);
    setPageInert(m);
    document.documentElement.style.overflow = 'hidden';
    var closeBtn = m.querySelector('.bek-eye-modal__close');
    if (closeBtn) setTimeout(function () { try { closeBtn.focus({ preventScroll: true }); } catch (e) {} }, 30);
    return m;
  }

  /* YouTube-Fallback, wird nur noch von Bannern ohne Shopify-CDN-Video genutzt */
  function openYouTube(id) {
    buildModal('<iframe src="https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0" title="Produktvideo" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');
  }

  /* Shopify-CDN-Video. Erst beim Klick wird ueberhaupt eine Videodatei angefragt.
     Quellenwahl: progressive MP4 zuerst, weil sie in jedem Browser laeuft.
     HLS nur, wenn Shopify keine MP4-Quelle liefert - dann kann Safari sie nativ abspielen.
     Absichtlich KEIN canPlayType-Test auf application/vnd.apple.mpegurl: Chrome antwortet
     darauf mit "maybe", kann HLS aber nicht abspielen, das Video bliebe schwarz. */
  function openFile(mp4, hls, poster, title) {
    var src = mp4 || hls;
    if (!src) return;
    var m = buildModal('<video class="bek-eye-modal__video" controls autoplay playsinline preload="auto"' +
      (poster ? ' poster="' + poster.replace(/"/g, '&quot;') + '"' : '') +
      (title ? ' title="' + title.replace(/"/g, '&quot;') + '"' : '') + '></video>', title || 'Produktvideo');
    var v = m.querySelector('video');
    if (!v) return;
    v.src = src;
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var el = e.target.closest('[data-bek-eye-nav],[data-bek-eye-dot],[data-bek-eye-axis],[data-bek-eye-video],[data-bek-eye-video-src],[data-bek-eye-video-hls],[data-bek-eye-modal-close]');
    if (!el) return;
    if (el.hasAttribute('data-bek-eye-modal-close')) { e.preventDefault(); closeModal(); return; }
    /* Grid video cards live outside a product-family banner. Keep their YouTube
       facade globally clickable while the iframe is still created only on demand. */
    if (el.hasAttribute('data-bek-eye-video')) { e.preventDefault(); openYouTube(el.getAttribute('data-bek-eye-video')); return; }
    var root = el.closest('[data-bek-eye]');
    if (!root) return;
    e.preventDefault();
    if (el.hasAttribute('data-bek-eye-video-src') || el.hasAttribute('data-bek-eye-video-hls')) {
      openFile(
        el.getAttribute('data-bek-eye-video-src'),
        el.getAttribute('data-bek-eye-video-hls'),
        el.getAttribute('data-bek-eye-video-poster'),
        el.getAttribute('data-bek-eye-video-title')
      );
      return;
    }
    if (el.hasAttribute('data-bek-eye-video')) { openYouTube(el.getAttribute('data-bek-eye-video')); return; }
    eagerAll(root);
    var cur = parseInt(root.getAttribute('data-bek-eye-index') || '1', 10);
    if (el.hasAttribute('data-bek-eye-axis')) {
      /* Eine Achse wechseln, die andere so lassen wie sie ist. Gibt es die
         Kombination nicht, wird der erste Slide der neuen Achse genommen. */
      var axis = el.getAttribute('data-bek-eye-axis');
      var val = el.getAttribute('data-axis-value');
      root.setAttribute('data-selected-' + axis, val);
      var act = root.querySelector('[data-bek-eye-slide].is-active');
      var axes = ['color', 'l2', 'l3'];
      var all = root.querySelectorAll('[data-bek-eye-slide]');
      var hit = null, first = null;
      for (var s2 = 0; s2 < all.length; s2++) {
        var axisPrimary = all[s2].getAttribute('data-axis-' + axis);
        var axisAlternate = all[s2].getAttribute('data-axis-' + axis + '-alt');
        if (axisPrimary !== val && axisAlternate !== val) continue;
        if (!first) first = all[s2];
        var exact = true;
        for (var ai = 0; ai < axes.length; ai++) {
          var other = axes[ai];
          if (other === axis || !act) continue;
          var keep = root.getAttribute('data-selected-' + other) || act.getAttribute('data-axis-' + other);
          var candidatePrimary = all[s2].getAttribute('data-axis-' + other);
          var candidateAlternate = all[s2].getAttribute('data-axis-' + other + '-alt');
          if (keep !== null && keep !== '' && candidatePrimary !== keep && candidateAlternate !== keep) {
            exact = false;
            break;
          }
        }
        if (exact) { hit = all[s2]; break; }
      }
      var target = hit || first;
      if (target) setSlide(root, parseInt(target.getAttribute('data-bek-eye-slide'), 10), true);
      return;
    }
    if (el.hasAttribute('data-bek-eye-dot')) {
      setSlide(root, parseInt(el.getAttribute('data-bek-eye-dot'), 10), true);
    } else {
      var step = parseInt(el.getAttribute('data-bek-eye-nav'), 10);
      var act2 = root.querySelector('[data-bek-eye-slide].is-active');
      var hasL3 = act2 && act2.getAttribute('data-axis-l3');
      if (hasL3) {
        setSlide(root, cur + step, true);
        return;
      }
      var hasL2 = act2 && act2.getAttribute('data-axis-l2');
      if (hasL2) {
        /* Zweidimensionaler Banner: die Pfeile laufen durch ALLE Kombinationen.
           Erst die Farben der aktuellen zweiten Ebene, danach springt die zweite
           Ebene weiter und die Farben werden dort erneut durchlaufen. Die
           Reihenfolge kommt aus den Achswerten, nicht aus der DOM-Reihenfolge,
           damit auch gemischt sortierte Familien sauber durchlaufen. */
        var colors = axisValues(root, 'color');
        var l2s = axisValues(root, 'l2');
        var total = colors.length * l2s.length;
        if (total > 1) {
          var ci = colors.indexOf(act2.getAttribute('data-axis-color'));
          var li = l2s.indexOf(act2.getAttribute('data-axis-l2'));
          if (ci < 0) ci = 0;
          if (li < 0) li = 0;
          var flat = li * colors.length + ci;
          /* Luecken in der Matrix ueberspringen statt ins Leere zu klicken. */
          for (var k = 1; k <= total; k++) {
            var nf = ((flat + step * k) % total + total) % total;
            var nl = Math.floor(nf / colors.length);
            var nc = nf - nl * colors.length;
            var tg = findSlide(root, colors[nc], l2s[nl]);
            if (tg) { setSlide(root, parseInt(tg.getAttribute('data-bek-eye-slide'), 10), true); return; }
          }
          return;
        }
      }
      setSlide(root, cur + step, true);
    }
  });

  /* Bild und Titel sind echte Links. Ein Klick auf freie Bannerflaeche folgt
     ebenfalls dem aktuell gewaehlten Modell. Bedienelemente bleiben davon ausgenommen. */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var root = e.target.closest('[data-bek-eye]');
    if (!root) return;
    if (e.target.closest('a,button,input,select,textarea,label,[role="button"],video,iframe')) return;
    var selection = window.getSelection ? window.getSelection() : null;
    if (selection && String(selection).length) return;
    var url = root.getAttribute('data-bek-eye-current-url');
    if (url) window.location.href = url;
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });

  /* is-ready schaltet die Transitions frei. Ohne die Klasse wuerde der erste Aufbau
     mitanimieren, der Banner also sichtbar hineingleiten. */
  function initMobileSelects(root) {
    var groups = root.querySelectorAll('.bek-eye__level2');
    for (var g = 0; g < groups.length; g++) {
      var group = groups[g];
      if (group.nextElementSibling && group.nextElementSibling.classList.contains('bek-eye__mobile-select-shell')) continue;
      var buttons = group.querySelectorAll('button[data-bek-eye-axis][data-axis-value]');
      if (!buttons.length) continue;
      var axis = buttons[0].getAttribute('data-bek-eye-axis');
      var shell = document.createElement('div');
      shell.className = 'bek-eye__mobile-select-shell';
      var select = document.createElement('select');
      select.className = 'bek-eye__mobile-select';
      select.setAttribute('data-bek-eye-mobile-select', axis);
      select.setAttribute('aria-label', group.getAttribute('aria-label') || 'Option wählen');
      for (var b = 0; b < buttons.length; b++) {
        var option = document.createElement('option');
        option.value = buttons[b].getAttribute('data-axis-value');
        option.textContent = buttons[b].textContent.trim();
        option.selected = buttons[b].classList.contains('is-active');
        select.appendChild(option);
      }
      shell.appendChild(select);
      group.parentNode.insertBefore(shell, group.nextSibling);
      var ralLink = group.querySelector('a[data-bek-eye-ral]');
      if (ralLink) {
        var mobileRalLink = ralLink.cloneNode(true);
        mobileRalLink.classList.add('bek-eye__ral--mobile');
        group.parentNode.insertBefore(mobileRalLink, shell.nextSibling);
      }
      (function (sel, sourceButtons) {
        sel.addEventListener('change', function () {
          for (var x = 0; x < sourceButtons.length; x++) {
            if (sourceButtons[x].getAttribute('data-axis-value') === sel.value) {
              sourceButtons[x].click();
              break;
            }
          }
        });
      })(select, buttons);
    }
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-bek-eye]');
    for (var i = 0; i < roots.length; i++) {
      var r = roots[i];
      initMobileSelects(r);
      if (r.classList.contains('is-ready')) continue;
      if (!r.getAttribute('data-dir')) r.setAttribute('data-dir', '1');
      setSlide(r, parseInt(r.getAttribute('data-bek-eye-index') || '1', 10), false);
      (function (el) {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { el.classList.add('is-ready'); });
        });
      })(r);
    }
  }

  function boot() {
    initAll();
    var target = document.getElementById('CollectionAjaxContent');
    if (target && 'MutationObserver' in window) {
      new MutationObserver(function () {
        if (suppress) return;
        initAll();
      }).observe(target, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();